// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".table-config-link-d321d{color:var(--GRAY_11)!important}.table-config-link-disabled-d4912{color:var(--GRAY_6)!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"link": "table-config-link-d321d",
	"link-disabled": "table-config-link-disabled-d4912",
	"linkDisabled": "table-config-link-disabled-d4912"
};
export default ___CSS_LOADER_EXPORT___;
